var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChartCirclePieColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 2.12005V13.88C7.33331 14.3067 6.93998 14.6267 6.52665 14.5334C3.54665 13.8667 1.33331 11.1934 1.33331 8.00005C1.33331 4.80672 3.54665 2.13338 6.52665 1.46672C6.93998 1.37338 7.33331 1.69338 7.33331 2.12005Z",
    fill: "#049EB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 9.33962V13.8773C8.66669 14.3038 9.06073 14.6236 9.48149 14.5304C11.9927 13.964 13.9629 11.985 14.5306 9.47955C14.6241 9.06643 14.2969 8.66663 13.8761 8.66663H9.34124C8.96723 8.67329 8.66669 8.97314 8.66669 9.33962Z",
    fill: "#D5146D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 2.1234V6.66628C8.66669 7.03318 8.96756 7.33337 9.33529 7.33337H13.8751C14.303 7.33337 14.624 6.93979 14.5304 6.51952C13.962 4.01127 11.9897 2.03668 9.48239 1.46966C9.06116 1.37627 8.66669 1.69647 8.66669 2.1234Z",
    fill: "#F5B000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChartCirclePieColored);
export default __webpack_public_path__ + "static/media/ico-chart-circle-pie-colored.a8770380d6514ef5ad0cd8b7b2f4f774.svg";
export { ForwardRef as ReactComponent };